define('app/sdc/repeat/sdc-repeat',["$q"], function ($q) {
	"use strict";
	return {
		restrict: "A",
		controller: {

		}
	};
});
